import React, { useEffect, useState } from "react"
import { beautifyMsToHMSString, DAY_IN_MS } from "../../utility/common/time"
import useBeforeUnload from "../../hooks/useBeforeUnload"
import { SelectedOperatorStatus } from "../../models/operatorStatus"
import { useAppDispatch } from "../../store/hooks"
import { testId } from "../../utility/tests/testId/menu"
import { useTranslation } from "react-i18next"
import { saveStatusTimer } from "../../store/userOperator/actions"

const tNamespace = "operator"

export interface OperatorStatusTimerProps {
    status: SelectedOperatorStatus
}

const OperatorStatusTimer: React.FC<OperatorStatusTimerProps> = ({ status }) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation(tNamespace)
    const prevStatusTimestamp = status.StatusSetTime ?? Date.now()
    const [elapsedTime, setElapsedTime] = useState(0)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const updateTimer = () => {
            const ms = Date.now() - prevStatusTimestamp
            setElapsedTime(ms)
            if (isLoading) {
                setIsLoading(false)
            }
        }

        updateTimer()

        const timerId = setInterval(updateTimer, 1000)

        return () => {
            if (timerId) {
                clearInterval(timerId)
            }
        }
    }, [prevStatusTimestamp, isLoading])

    useBeforeUnload(() => {
        dispatch(saveStatusTimer(status, prevStatusTimestamp, true))
    })

    return (
        <div data-testid={testId.operatorStatusTimer}>
            {isLoading ? (
                <span style={{ opacity: 0.6, fontSize: "0.9em" }}>--:--:--</span>
            ) : elapsedTime > DAY_IN_MS ? (
                t("timer-more-than-day")
            ) : (
                beautifyMsToHMSString(elapsedTime)
            )}
        </div>
    )
}

export default OperatorStatusTimer
